import type { Language } from '@offer-catalog/services/i18n'
import type { Department, DepartmentWithSubdepartments, Universe } from '@/types/treeViewTypes'

export type BreadcrumbLevel
  = | 'universe'
    | 'department'
    | 'subdepartment'
    | 'family'

export type BreadcrumbLevels = {
  level: BreadcrumbLevel
  id: number
  label: string
}[]

export function getBreadcrumbForSubdepPage(fullDepartment: DepartmentWithSubdepartments, currentLanguage: Language) {
  const formatted: BreadcrumbLevels = [
    {
      level: 'universe',
      id: fullDepartment.universe.id,
      label:
        fullDepartment.universe.labels[currentLanguage]
        || fullDepartment.universe.id.toString(),
    },
  ]
  return formatted
}

export function getBreadcrumbForProductsPage({ universe, department, currentLanguage }: {
  universe: Universe
  department: Department
  currentLanguage: Language
}) {
  const formatted: BreadcrumbLevels = [
    {
      level: 'universe',
      id: universe?.id,
      label:
        universe?.labels[currentLanguage]
        || universe?.id.toString(),
    },
    {
      level: 'department',
      id: department?.id,
      label:
        department?.labels[currentLanguage]
        || department?.id.toString(),
    },
  ]
  return formatted
}
